import React, { useState } from "react";
import { useUserContext } from "../../../Context/UserContext"; // Correctly accessing user context
import { useNavigate } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import styles from "./Sidebar.module.css";
import menuLogo from "./../../../images/sidebar_logo.png";
import { jwtDecode } from "jwt-decode";

const Sidebar = () => {
  const { getToken } = useUserContext(); // Accessing user context
  const navigate = useNavigate();
  const [openDrawer, setOpenDrawer] = useState(false);

  // Toggle drawer open/close
  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  // Navigation
  const handleDashboardClick = () => {
    navigate("/");
    setOpenDrawer(false);
  };

  const handleRegisterAdmin = () => {
    navigate("/admin");
    setOpenDrawer(false);
  };

  const handleRestaurantList = () => {
    navigate("/restaurants");
    setOpenDrawer(false);
  };

  const handleReports = () => {
    navigate("/reports");
    setOpenDrawer(false);
  };

  const handleBookings = () => {
    navigate("/bookings");
    setOpenDrawer(false);
  };

  const handleDiners = () => {
    navigate("/diners");
    setOpenDrawer(false);
  };

  const handleCoupons = () => {
    navigate("/coupons-offers");
    setOpenDrawer(false);
  };

  const handleReviews = () => {
    navigate("/reviews");
    setOpenDrawer(false);
  };
  return (
    <div>
      {/* Button to open the sidebar */}
      <div className={styles.tooltipContainer}>
        <Tooltip title="Menu" arrow>
          <IconButton
            edge="start"
            className={styles.burgerMenuIcon}
            color="inherit"
            onClick={toggleDrawer}
          >
            <MenuIcon sx={{ color: "#EFE4CB" }} />
          </IconButton>
        </Tooltip>
      </div>

      {/* Sidebar/Drawer */}
      <Drawer anchor="left" open={openDrawer} onClose={toggleDrawer}>
        <div
          role="presentation"
          onClick={toggleDrawer}
          onKeyDown={toggleDrawer}
        >
          <List>
            <div className={styles.welcomeText}>
              {/* <div className={styles.logoAndRole}> */}
              {/* conButton */}
              <img src={menuLogo} alt="Menu Logo" className={styles.menuLogo} />
              <p className={styles.userRole}>
                {`Hello ${
                  getToken()
                    ? (() => {
                        const user = jwtDecode(getToken());
                        const first = user?.firstName?.[0] || "";
                        const last = user?.lastName?.[0] || "";
                        return `${first}${last}`.toUpperCase();
                      })()
                    : "User"
                }`}
                {/* {userRole() === 'superadmin' ? 'Super Admin' : 'Admin'} */}
              </p>
              {/* </div> */}
            </div>

            <>
              <div className={styles.menuListContainer}>
                <ListItem onClick={handleDashboardClick}>
                  <ListItemText
                    className={styles.menuFont}
                    primary="Dashboard"
                  />
                </ListItem>
              </div>

              <div className={styles.menuListContainer}>
                <ListItem onClick={handleRegisterAdmin}>
                  <ListItemText
                    className={styles.menuFont}
                    primary="Administration"
                  />
                </ListItem>
              </div>

              <div className={styles.menuListContainer}>
                <ListItem onClick={handleRestaurantList}>
                  <ListItemText
                    className={styles.menuFont}
                    primary="Restaurants"
                  />
                </ListItem>
              </div>

              <div className={styles.menuListContainer}>
                <ListItem onClick={handleBookings}>
                  <ListItemText
                    className={styles.menuFont}
                    primary="Bookings"
                  />
                </ListItem>
              </div>

              <div className={styles.menuListContainer}>
                <ListItem onClick={handleDiners}>
                  <ListItemText className={styles.menuFont} primary="Diners" />
                </ListItem>
              </div>

              <div className={styles.menuListContainer}>
                <ListItem onClick={handleReports}>
                  <ListItemText
                    className={styles.menuFont}
                    primary="Bill Payments"
                  />
                </ListItem>
              </div>

              <div className={styles.menuListContainer}>
                <ListItem onClick={handleCoupons}>
                  <ListItemText
                    className={styles.menuFont}
                    primary="Coupons & Offers"
                  />
                </ListItem>
              </div>

              <div className={styles.menuListContainer}>
                <ListItem onClick={handleReviews}>
                  <ListItemText
                    className={styles.menuFont}
                    primary="Diner Reviews"
                  />
                </ListItem>
              </div>
            </>
          </List>
          <div className={styles.copyrightContainer}>
            <Typography>
              &copy; {new Date().getFullYear()} DiNEST - rights reserved.
              <br /> Developed by Hostedminds&trade;
            </Typography>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default Sidebar;
